import { MessageCircle, X } from 'lucide-react';

import { chatVisitor, type VisitorState } from '~/lib/chat-visitor';
import { PANEL_ID } from './ChatPanel';

export function ChatLauncher({ state, mounted }: { state: VisitorState; mounted: boolean }) {
  return (
    <>
      {/* De omroeper staat HIER en niet in het paneel, zodat hij ook bestaat als
          het paneel dicht is — dan moet een nieuw bericht immers nog steeds
          gemeld worden. Eén live region voor de hele widget: het transcript
          zelf staat op aria-live="off", anders wordt alles dubbel omgeroepen. */}
      <p className="sr-only" role="status" aria-live="polite" aria-atomic="true">
        {state.announcement}
      </p>

      <button
        type="button"
        onClick={() => chatVisitor.toggle()}
        aria-expanded={state.panelOpen}
        aria-controls={PANEL_ID}
        aria-label={state.panelOpen ? 'Chat sluiten' : 'Chat met LEZA support'}
        // Voor de forced-colors-regel in theme.css: zonder achtergrond blijft
        // anders alleen een zwevend icoon over.
        data-kb-fab
        className="fixed right-5 z-200 flex size-14 items-center justify-center rounded-full bg-accent text-accent-on shadow-lg transition hover:bg-accent-hover hover:shadow-glow kb-no-print motion-safe:animate-fade-up"
        // De leerpadbalk onderaan een artikel schuift deze knop omhoog; buiten
        // een leerpad is de variabele 0px en verandert er niets.
        style={{
          bottom: 'max(1.25rem, calc(1.25rem + env(safe-area-inset-bottom)))',
          marginBottom: 'var(--kb-stepbar-h, 0px)',
        }}
      >
        {state.panelOpen ? <X size={22} aria-hidden /> : <MessageCircle size={22} aria-hidden />}

        {/* Pas ná de hydratatie: vóór die tijd weet de server niet hoeveel
            ongelezen berichten er zijn, en een badge die verschijnt en weer
            verdwijnt leest als een storing. Zelfde aanpak als ThemeToggle.tsx:34-35. */}
        {mounted && state.unread > 0 && !state.panelOpen && (
          <span className="absolute -top-0.5 -right-0.5 min-w-4 rounded-full bg-danger px-1 text-2xs font-bold text-on-semantic tabular-nums">
            {state.unread > 9 ? '9+' : state.unread}
          </span>
        )}
      </button>
    </>
  );
}
